import SiteMapping from '../configs/siteMapping';

const gotoLandingPage = (url) => {
    window.location = url;
};

const gotoCasino = (url) => {
    window.location = url;
    // https://sealroyaleib.sealintg.net/
};

const gotoNovaCasino = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
    // http://novacasino-landing-001.nonsports.t1u.oneops.net
}

const joinNow = (siteName, lang, url) => {
    switch (siteName) {
    case SiteMapping.viva88:
    case SiteMapping.bong88:
        gotoLandingPage(url);
        break;
    case SiteMapping.Nova88:
        gotoNovaCasino(url);
        break;
    case SiteMapping.IBCBet:
        gotoCasino(url);
        break;
    default:// pica/id8899 dont have join now btn
        break;
    }
};

const gotoAppDownload = (userlang, siteName , ip , showPlatform, showPosition ) => {
    let url = `https://www.winwin999.net?bt={0}&pd=sports&lang={1}&platform=${showPlatform}&ip=${ip}&position=${showPosition}`;

    const lang = {
        [userlang]: 'en',
        en: 'en',
        vn: 'vn',
        ch: 'zh-tw',
        cs: 'zh-cn',
        zhcn: 'zh-cn',
    }[userlang];

    const siteString = {
        [siteName]: 'GueGhmPRxEWbbp3FIbpqPA',
        [SiteMapping.Nova88]: 'GueGhmPRxEWbbp3FIbpqPA',
        [SiteMapping.viva88]: 'Rl89LflI4EaoNIdu2zzeVw',
        [SiteMapping.IBCBet]: 'QTQanXruEEur8ihzdYoF3A',
    }[siteName];

    url = url.replace('{0}', siteString);
    url = url.replace('{1}', lang);
    window.open(url);
};
const domainName = () => {
    const dotIndex = window.location.hostname.indexOf('.');
    const domainname = window.location.hostname.substring(dotIndex + 1);
    return domainname;
};

const gotoWAP = () => {
    const host = domainName(window.location.host);
    // window.location = `http://wap.${host}`;
    window.open(`http://wap.${host}`);
};

const redirectTo = (platform) => {
    switch (platform) {
    case 'm':
        window.location.href = `http://m.${domainName()}`;
        break;
    default:
        break;
    }
};

export {
    joinNow,
    gotoWAP,
    gotoAppDownload,
    redirectTo,
};
